import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../auth.service';

@Component({
  selector: 'tnt-administration',
  templateUrl: './administration.component.html',
  host: { 'class': 'router-outlet' },
  // styleUrls: ['./administration.component.scss']
})
export class TntAdministrationComponent implements OnInit {

  constructor(
    public router: Router,
    public authService: AuthenticationService
  ) { }

  ngOnInit() { }

}
